import { TmBaseError } from '@/core/error/tmBaseError'

export class TmDateTimeError extends TmBaseError {
  public name = 'TmDateTimeError'
}
